export type MetaGetter = (name: string) => string | null;

export const getMeta: MetaGetter = (name: string): string | null => {
	// NOTE: this code in this __SERVER__ block has been copied from the `server.tsx` file, please keep them in sync until the flag is rolled out

	// `document` doesn't work in Node envs
	if (__SERVER__) {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		const value = globalThis.ssr__metadata && globalThis.ssr__metadata[name];
		return value !== undefined ? value : null;
	}

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const node = document.querySelector(`meta[name="${name}"]`);
	const metaValue = node && node.getAttribute('content');
	return metaValue !== undefined ? metaValue : null;
};

export default getMeta;
